import React from "react";
import { Link } from "react-router-dom";
import imageOne from './images/two (5) 1 (1).png';
import imageTwo from './images/three (1) 1.png';
import imageThree from './images/one (7) 1.png';
import imageFour from './images/front-page 1.png';
import imageFive from './images/middle-page 1.png';
import imageSeven from './images/back-page 1.png';
import imageEight from './images/one (8).jpg';
import imageNine from './images/one (9).jpg';
import imageTen from './images/one (10).jpg';
import imageEleven from './images/one (11).jpg';
import imageTwelve from './images/mediamodifier_image (2) 1 1.png'
import imageThirten from './images/mediamodifier_image (4) 1 1.png';
import imageFourteen from './images/z-fold-mockup 1.png';
import imageFifteen from './images/sandwich-board-mockup 1.png';
import imageSixteen from './images/Screenshot 2024-11-17 112747.png';
import imageSeventeen from './images/Screenshot 2024-11-17 113102.png'
import imageEighteen from './images/Screenshot 2024-11-17 113326.png';

export default function OutSurance(){
    return(
        <div className="ExperienceSection container-fluid experience_section_parent_wrapper">
            <div className="experience_section_child_wrapper">
                <div className="container experience_content_wrapper py-4">
                    <h4 className="project_heading font-weight-bold mt-5 text-success" style={{fontSize:"28pt",fontWeight:'700'}}>
                        OUTSurance Portfolio
                    </h4>
                    <div className="row gx-2 gy-4 project_row mt-2">
                        <h3>Flat Images</h3>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageOne} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mt-3">
                           
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageTwo} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageThree} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageFour} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageFive} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageSeven} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-6 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageEight} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-6 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageNine} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-6 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageTen} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-6 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageEleven} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <h2 className="font-weight-bold" style={{fontWeight:'800'}}>Mockups</h2>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-6 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageTwelve} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-6 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageThirten} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-6 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageFourteen} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-6 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageFifteen} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <h2 className="font-weight-bold" style={{fontWeight:'800'}}>Social Media</h2>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-10 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageSixteen} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-10 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageSeventeen} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-10 mt-3">
                            
                            <div className="card ux_section_card">
                                <div className="card-img-top py-3">
                                    <img src={imageEighteen} alt="" className="img-fluid mx-auto project_col_img" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-10 mt-3">
                        <div class="sp-embed-player" data-id="cZXFVinVqiV"><script src="https://go.screenpal.com/player/appearance/cZXFVinVqiV"></script><iframe width="100%" height="100%" style={{border:0,height:"500px"}} scrolling="no" src="https://go.screenpal.com/player/cZXFVinVqiV?width=100%&height=100%&ff=1&title=0" allowfullscreen="true"></iframe></div>

                        </div>
                    </div>
                    <br />
                    <h3 className="background_title font-weight-bolder mt-4">
                        Cover Letter 
                    </h3>
                    <p>
                        Dear Hiring Manager , I hope this message finds you well ,
                        If you have made it this far thank you ,
                        <br />
                        I believe you see potential in me and my portfolio as well as experience .
                        With that being said I made this custom portfolio to show my keen interest in the role 

                    </p>
                    <p>
                        <b>I am a Multimedia Designer and Developer</b><br />
                        <b>I am an all-rounder with a marketing background - passion for copywriting and UX writting</b><br />
                        <b>Design and Development wise I excel , I am an excellent Visual Design Communicator and Developer</b><br />
                        <b className="text-primary">Take a shot at me and you might just have the best of the best in your team</b><br />
                        <b className="text-success">It is all on GOD and You Now : <i>I AM THE GUY FOR THIS ROLE TAKE A SHOT AT ME YOU WONT REGRET IT !!!</i></b>
                        <b></b>
                    </p>
                    
                </div>
            </div>
        </div>
    );
}